// src/pages/hr/recruitment/RecruitmentActivity.jsx
import React from "react";
import { useRecruitmentContext } from "../../../context/RecruitmentContext";

export default function RecruitmentActivity() {
  const { activityLogs, activityLoading } = useRecruitmentContext();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
      <style>{`
        .act-table { width: 100%; border-collapse: collapse; font-size: 0.84rem; background: var(--bg-card, #fff); border-radius: 12px; overflow: hidden; border: 1px solid var(--border, #e5e7eb); box-shadow: 0 1px 5px rgba(0,0,0,0.05); }
        .act-table th { background: var(--bg-secondary, #f9fafb); text-align: left; padding: 0.7rem 0.9rem; font-size: 0.74rem; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 2px solid var(--border, #e5e7eb); }
        .act-table td { padding: 0.75rem 0.9rem; border-bottom: 1px solid var(--border, #f3f4f6); vertical-align: middle; color: var(--text-primary, #111); }
      `}</style>

      <div>
        <h3 style={{ margin: 0, fontWeight: 700, fontSize: "1.05rem" }}>Recruitment Audit Trail & Logs</h3>
        <span style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>
          Immutable system log of candidate stage updates, job changes, and offer events
        </span>
      </div>

      {activityLoading ? (
        <div style={{ textAlign: "center", padding: "3rem", color: "var(--text-muted)" }}>Loading Audit Trail...</div>
      ) : activityLogs.length === 0 ? (
        <div style={{ background: "var(--bg-card, #fff)", border: "1px dashed var(--border)", borderRadius: 12, padding: "3rem", textAlign: "center", color: "var(--text-muted)" }}>
          No recruitment activity recorded yet.
        </div>
      ) : (
        <table className="act-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>User / Actor</th>
              <th>Action</th>
              <th>Entity / Candidate</th>
              <th>Old Value</th>
              <th>New Value</th>
            </tr>
          </thead>
          <tbody>
            {activityLogs.map((log) => (
              <tr key={log.id}>
                <td style={{ fontSize: "0.78rem", color: "var(--text-muted)", whiteSpace: "nowrap" }}>
                  {log.createdAt?.toDate ? log.createdAt.toDate().toLocaleString("en-IN") : "—"}
                </td>
                <td style={{ fontWeight: 600 }}>{log.actorName || "System"}</td>
                <td>
                  <span style={{ background: "#dbeafe", color: "#1e40af", padding: "0.15rem 0.55rem", borderRadius: 99, fontSize: "0.72rem", fontWeight: 700 }}>
                    {log.action}
                  </span>
                </td>
                <td style={{ fontWeight: 600 }}>{log.entityName || log.candidateId || "—"}</td>
                <td style={{ color: "var(--text-muted)" }}>{log.oldValue || "—"}</td>
                <td style={{ fontWeight: 700, color: "#1b4b31" }}>{log.newValue || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
